import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18b575c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "order-column"
}
const _hoisted_2 = {
  key: 2,
  class: "ml-3"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Fulfillment Warning")
const _hoisted_4 = { style: {"font-size":"0.75rem"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Created:", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Approved:", -1))
const _hoisted_8 = {
  key: 1,
  class: "text-xs text-warning",
  type: "warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.isOrderExporter)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.props.scope.row['orderName']), 1))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: {
        name: 'agency.orders.detail',
        params: { id: _ctx.props.scope.row._id },
      },
            class: "text-primary font-bold"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.props.scope.row['orderName']), 1)
            ]),
            _: 1
          }, 8, ["to"])),
      (
        _ctx.props.scope.row?.fulfillmentWarning ||
        _ctx.props.scope.row.addressValid === 0
      )
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createVNode(_component_el_popover, {
              placement: "top-start",
              width: "auto",
              trigger: "hover"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_icon, { style: {"color":"red"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Warning)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { class: "text-x font-bold" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    (_ctx.props.scope.row?.fulfillmentWarning)
                      ? (_openBlock(), _createBlock(_component_el_row, {
                          key: 0,
                          class: "mt-3 font-light"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getWarningContent(_ctx.props.scope.row?.fulfillmentWarning)), 1)
                          ]),
                          _: 1
                        }))
                      : (_ctx.props.scope.row.addressValid === 0)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 1,
                            class: "mt-3 font-light"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, _toDisplayString(_ctx.props.scope.row?.errorMsg || 'Address Invalid!'), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", _hoisted_4, [
      _createElementVNode("p", null, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.props.scope.row.createdAt ?? _ctx.props.scope.row.createdDate)), 1)
      ]),
      (_ctx.props.scope.row?.approveDate)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.props.scope.row.approveDate)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.props.scope.row?.agencyNote)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.props.scope.row?.agencyNote), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}